import React from 'react';
import ToDoListItem from './todo-list-item';

const ToDoList=({todos , eventDelete , toggleDone , toggleImportant})=>{

    const elements=todos.map(elem=>{
    let ClassNames="list-group-item";
    let {visible}=elem;

    if(visible===false)
        ClassNames+=' hidden';
        
    let { id , ...itemsProps}=elem;
        return (
            <li key={id} className={ClassNames}>
                <ToDoListItem {...itemsProps}
                eventDelete={()=>eventDelete(id)}
                toggleDone={()=>toggleDone(id)}
                toggleImportant={()=>toggleImportant(id)}
                />
            </li>
        );
    });

    return (
        <ul className="list-group todo-list">
            {elements}
        </ul>
    );
}
export default ToDoList;